import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';

/**
 * enums
 */
import { STATUS_TYPE } from 'src/app/core/enums/ads/status-types';
import { CATEGOR_VALUE_TYPE } from 'src/app/core/enums/category/cate-value-types';

/**
 * interfaces
*/
import { IRega } from 'src/app/core/interfaces/ads/rega';
import { IMainFeature } from 'src/app/core/interfaces/ads/feature';
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';

/**
 * services
 */
import { GlobleService } from 'src/app/core/services/globle.service';
import { AdOperationService } from 'src/app/core/services/ad/ad-operations/ad-operations.service';
import { URL_TYPE } from 'src/app/core/enums/http-request/resources-url/resources-url-types';

@Component({
  selector: 'app-advertisement-details',
  templateUrl: './advertisement-details.component.html',
  styleUrls: ['./advertisement-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvertisementDetailsComponent implements OnInit {

  /************  ViewChild  ************/
  /**
   * @description get HTMLParagraphElement to handler it long text
   */
  @ViewChild('description') private _description: ElementRef<HTMLParagraphElement>;

  /************  Inputs  ************/
  /**
   * data
   * @description Advertisement Data
   */
  @Input({ alias: 'data', required: true }) public AdvertisementData: IAdvertisementResponse = null;

  /**
   * regaData
   * @description rega Data
   */
  @Input({ alias: 'regaData', required: true }) public RegaAdvertisementData: IRega = null;

  /************  OutPuts  ************/
  /**
   * DepositEventHandler
   * @description to emit click trigger for pay
   */
  @Output('deposit') public DepositEventHandler: EventEmitter<void> = new EventEmitter<void>();
  
  
  /************  fields  ************/
  /**
   * IsDescriptionCollapsed
   */
  public IsDescriptionCollapsed: boolean = false;

  /**
   * IsUnitDetailsCollapsed
   */
  public IsUnitDetailsCollapsed: boolean = false;  


  /************  Accessors  ************/
  /**
   * IsAvailable
   * @description check if Advertisement is available to show in Ui
   */
  public get IsAvailable(): boolean {
    return this.AdvertisementData.available;
  }

  /**
   * @description check if owner ad is current auth user
   */
  public get IsOwner(): boolean {

    // ES6 Destruction
    const { owner: { id } } = this.AdvertisementData;    

    /**
     * 
     */
    return this._g.CorrectUserId == id;

  }  

  /**
   * @description check if owner ad is has MarketPlace
   */
  public get IsOwnerHasMarketPlace(): boolean {
    
    // ES6 Destruction
    const { owner: { isMarketPlace } } = this.AdvertisementData;

    /**
     * 
     */
    return isMarketPlace;

  }  

  /**
   * @description Check if the number of lines of text is greater than a certain number
   */
  public get isDescriptionLineLimited(): boolean | null {

    /**
     * 
     */
    if (this._description == null) {
      return null
    }

    // ES6 Destruction
    const { 
      nativeElement: paragraph,
      nativeElement: { clientHeight, scrollHeight } 
    } = this._description;

    /**
     * 
     */
    const lineHeight = parseFloat(getComputedStyle(paragraph).lineHeight);
    // const collapseNumberOfLines = Math.round(clientHeight / lineHeight);
    const numberOfLines = Math.round(scrollHeight / lineHeight);

    /**
     * 
     */
    if (numberOfLines > 3) return true
    else return false

  }
  
  /**
   * _advertisementCategoryType
   * @returns categoryType of Advertisement
   */
  private get _advertisementCategoryType(): CATEGOR_VALUE_TYPE {

    try {
      
      // ES6 Destruction
      const { category: { type } } = this.AdvertisementData;
  
      /**
       * 
       */
      return type

    }
    catch(err) {
      // new Error
      return null
    }

  }

  /**
   * IsNormal
   * @description check if categoryType of Advertisement is Normal
   */
  public get IsNormal(): boolean {
    
    return this._adOperation.isNormal(this._advertisementCategoryType)

  }

  /**
   * IsBuilding
   * @description check if categoryType of Advertisement is Building
   */
  public get IsBuilding(): boolean {

    return this._adOperation.isBuilding(this._advertisementCategoryType);

  }

  /**
   * @description check if categoryType of Advertisement is OffPlanSale
   */
  public get IsOffPlanSale(): boolean {

    return this._adOperation.isOffPlanSale(this._advertisementCategoryType);

  }

  /**
   * IsPlaning
   * @description check if categoryType of Advertisement is Planning
   */
  public get IsPlaning(): boolean {

    return this._adOperation.isPlaning(this._advertisementCategoryType);

  }

  /**
   * Properties
   */
  public get Properties(): IMainFeature[] {
    
    // ES6 Destruction
    const { properties } = this.AdvertisementData;

    /**
     * 
     */
    return properties    

  }

  /**
   * handlerSize
   * @description get Size from RegaAdvertisementData or AdvertisementData to handler value
   */
  public get handlerSize(): string {

    // ES6 Destruction
    const { size } = this.AdvertisementData;
    const { propertyArea } = this.RegaAdvertisementData || {};

    /**
     * handler price returned from rega or infoAd
     */
    const Size = propertyArea || size;    
    
    /**
     * 
     */
    return this._adOperation.handlerSize(+Size);

  }

  /**
   * handlerPrice
   * @description get Price from RegaAdvertisementData or AdvertisementData to handler value
   */
  public get handlerPrice(): number | string | null{
    
    // ES6 Destruction
    const { price } = this.AdvertisementData;
    const { propertyPrice } = this.RegaAdvertisementData || {};

    /**
     * handler price returned from rega or infoAd
     */
    const Price = propertyPrice || price;

    /**
     * 
     */
    if (Price == null) return null;

    /**
     * 
     */
    return Price;

  }

  /**
   * isShowAdvertisementUnits
   * @description check if Advertisement type IsBuilding or  IsOffPlanSale
   */
  public get isShowAdvertisementUnits(): boolean {
    return this.IsBuilding || this.IsOffPlanSale
  }

  /**
   * STATUS_TYPE
   */
  public get STATUS_TYPE(): typeof STATUS_TYPE {
    return STATUS_TYPE
  }

  /**
   * URL_TYPE
   */
  public get URL_TYPE(): typeof URL_TYPE {
    return URL_TYPE
  }


  /**
   *
   */
  constructor(
    private _g: GlobleService,
    private _adOperation: AdOperationService
  ) {}

  ngOnInit(): void {}
  
  
  /************  Methods  ************/
  /**
   * isDescriptionCollapsed
   * @description show or hide long text for description
   */
  public ToggleDescriptionCollapse(): void {
    this.IsDescriptionCollapsed = !this.IsDescriptionCollapsed
  }

  /**
   * 
   * @param name ad property name
   * @returns ad property object
   * @description this function will find property == name then return it
   */
  public getPropertyDetails(name: string): {[key: string]: any} | null {

    /**
     * handler null value
     */
    if (this.Properties == null || !Array.isArray(this.Properties)) return null;

    /**
     * 
     */
    return this.Properties.find(p => p.redfKey == name)

  }

  /**
   * UnitDetailsToggleCollapse
   * @description show or hide others data of unit
   */
  public UnitDetailsToggleCollapse(): void {

    /**
     * 
     */
    this.IsUnitDetailsCollapsed = !this.IsUnitDetailsCollapsed

  } 
  
  /**
   * @description emit DepositEventHandler
   */
  public DepositPay(): void {

    this.DepositEventHandler.emit();

  }


}
